export var SettingsTabs;
(function (SettingsTabs) {
    SettingsTabs["SETTINGS"] = "settings";
    SettingsTabs["IMPORTER"] = "importer";
    SettingsTabs["PRESETS"] = "presets";
})(SettingsTabs || (SettingsTabs = {}));
